<template>
    <router-link :to="`/product/${productId}`">
        <div class="catalog-card">
            <!-- Фото товара -->
            <img v-if="photoUrl" :src="photoUrl" alt="Фото товара" />

            <!-- Название товара в стиле этикетки -->
            <div class="product-name-container">
                <div class="product-name">{{ productName }}</div>
            </div>

            <!-- Блок с этикетками -->
            <!-- TODO: Раскомментировать, когда будет готова основная часть -->
            <div class="labels-container">
              <div 
                class="label" 
                v-for="label in labels" 
                :key="label.id" 
                :style="{ backgroundColor: label.color }"
              >
                {{ label.label_name }}
              </div>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
  props: {
    productName: {
      type: String,
      required: true,
    },
    photoUrl: {
      type: String,
      default: null,
    },
    productId: {
      type: Number,
      required: true,
    },
    labels: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.catalog-card {
    width: 100%;
    height: 60vw;
    max-height: 60vw;
    position: relative;
    overflow: hidden;
    border-radius: 16px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.catalog-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.catalog-card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 16px;
    transition: transform 0.4s ease;
}

.catalog-card:hover img {
    transform: scale(1.05);
}

/* Название товара в стиле этикетки */
.product-name-container {
    position: absolute;
    bottom: 0;
    left: 12px;
    right: 12px;
    z-index: 2;
}

.product-name {
    display: inline-block;
    text-align: center;
    padding: 10px 14px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 600;
    font-family: 'CentureGothic', sans-serif;
    letter-spacing: 0.3px;
    line-height: 1.4;
    color: white;
    
    /* Стиль как у этикеток — стеклянный эффект */
    background-color: rgba(255, 255, 255, 0.12);
    border: 0.5px solid rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    
    /* Перенос текста */
    max-width: 100%;
    word-wrap: break-word;
    overflow-wrap: break-word;
    
    /* Максимальная высота — до 3 строк */
    max-height: 72px;
    overflow: hidden;
    
    /* Плавное появление */
    transition: all 0.2s ease;
}

.labels-container {
    position: absolute;
    top: 8px;
    left: 8px;
    right: 8px;
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
    z-index: 2;
}

.label {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 3px 7px;
    border-radius: 12px;
    font-size: 8px;
    font-weight: 700;
    font-family: 'CentureGothic', sans-serif;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    line-height: 1;
    height: 18px;
    position: relative;
    overflow: hidden;
    transition: all 0.2s ease;
    color: white;
}

.label:hover {
    transform: translateY(-1px);
}
</style>